// extracted by mini-css-extract-plugin
export var card = "_86-1";
export var container = "_86-0";